import { getFamilyInvite } from '@jotta/grpc-connect-openapi/esm/openapi/invite/v1/invite.v1-InviteService_connectquery'
import { createConnectQuery } from '../createConnectQuery'
import { useAuthenticated } from '@jotta/auth-client/useAuthStatus'
import { authTransport, publicTransport } from '../transport'

export const useFamilyInviteQuery = createConnectQuery(getFamilyInvite)

export function useFamilyInvite(familyInviteId: string) {
  const authenticated = useAuthenticated()
  return useFamilyInviteQuery({
    variables: { familyInviteId },
    enabled: Boolean(familyInviteId) && authenticated !== 'UNKNOWN',
    transport: authenticated === 'TRUE' ? authTransport : publicTransport,
  })
}
